/** 이 소스는 ACC Project에서 가져왔습니다. 자세한 문의는 하동혁 프로(1287)께 부탁드립니다. **/
export enum ACCTimerStatus {
    UNINITIALIZED, // 초기화 안됨
    INITIALIZED, // 초기화됨
    INACTIVE, // 액티브 안됨
    ACTIVE // 액태브 됨
}
